// -------------------------------------------
//   ANIMATIONS > SLIDE
// -------------------------------------------



// (((((((((( ~~~~~~~~~~ SLIDE IN ~~~~~~~~~~ )))))))))) //
const slideIn = {
	'@global': {
		// ***** SLIDE IN : DOWN ***** //
		'@keyframes slideInDown': {
			from: {
				transform: 'translate3d(0, -100%, 0)',
				visibility: 'visible'
			},
			to: {
				transform: 'translate3d(0, 0, 0)'
			}
		},
		// ***** SLIDE IN : LEFT ***** //
		'@keyframes slideInLeft': {
			from: {
				transform: 'translate3d(-100%, 0, 0)',
				visibility: 'visible'
			},
			to: {
				transform: 'translate3d(0, 0, 0)'
			}
		},
		// ***** SLIDE IN : RIGHT ***** //
		'@keyframes slideInRight': {
			from: {
				transform: 'translate3d(100%, 0, 0)',
				visibility: 'visible'
			},
			to: {
				transform: 'translate3d(0, 0, 0)'
			}
		},
		// ***** SLIDE IN : UP ***** //
		'@keyframes slideInUp': {
			from: {
				transform: 'translate3d(0, 100%, 0)',
				visibility: 'visible'
			},
			to: {
				transform: 'translate3d(0, 0, 0)'
			}
		}
	}
};


// (((((((((( ~~~~~~~~~~ SLIDE OUT ~~~~~~~~~~ )))))))))) //
const slideOut = {
	'@global': {
		// ***** SLIDE OUT : DOWN ***** //
		'@keyframes slideOutDown': {
			from: {
				transform: 'translate3d(0, 0, 0)'
			},
			to: {
				transform: 'translate3d(0, 100%, 0)',
				visibility: 'hidden'
			}
		},
		// ***** SLIDE OUT : LEFT ***** //
		'@keyframes slideOutLeft': {
			from: {
				transform: 'translate3d(0, 0, 0)'
			},
			to: {
				transform: 'translate3d(-100%, 0, 0)',
				visibility: 'hidden'
			}
		},
		// ***** SLIDE OUT : RIGHT ***** //
		'@keyframes slideOutRight': {
			from: {
				transform: 'translate3d(0, 0, 0)'
			},
			to: {
				transform: 'translate3d(100%, 0, 0)',
				visibility: 'hidden'
			}
		},
		// ***** SLIDE OUT : UP ***** //
		'@keyframes slideOutUp': {
			from: {
				transform: 'translate3d(0, 0, 0)'
			},
			to: {
				transform: 'translate3d(0, -100%, 0)',
				visibility: 'hidden'
			}
		}
	}
};



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export { slideIn, slideOut };